'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-react-router-scroll/~/react/react.js
// module id = 254
// module chunks = 168707334958949